import { graphql } from '@/gql';

import '../../gourmet/fragments/optionFieldsFragment';
import '../../gourmet/fragments/valueFieldsFragment';

graphql(`
  fragment ScheduledDeliveriesDetailedFragment on PaginatedDeliveryOrderResponse {
    count
    rows {
      id
      callerId
      caller {
        firstName
        lastName
        phoneNumber
        isRequiredMonitoringGourmetOrder
      }
      orderId
      preferredPhoneNumber
      isRedelivery
      originalOrderId
      natureOfComplaint
      clientName
      operatorId
      operator {
        firstName
        lastName
      }
      total
      service
      serviceAccount {
        email
        password
        phoneNumber
      }
      storeOrder {
        title
        subtitle
        phoneNumber
        address {
          formattedAddress
        }
        estimate {
          total
          serviceEstimateReference
          charges {
            title
            value
            originalValue
            tooltips {
              title
              value
            }
          }
          timeEstimate {
            min
            max
          }
          address {
            formattedAddress
            streetAddress2
          }
          promotion {
            promotionUuid
            text
            description
          }
          items {
            item {
              title
              price
              quantity
            }
            options {
              ...OptionsFields
              values {
                ...ValuesFields
                subOptions {
                  ...OptionsFields
                  values {
                    ...ValuesFields
                    subOptions {
                      ...OptionsFields
                      values {
                        ...ValuesFields
                        subOptions {
                          ...OptionsFields
                          values {
                            ...ValuesFields
                            subOptions {
                              ...OptionsFields
                              values {
                                ...ValuesFields
                                subOptions {
                                  ...OptionsFields
                                  values {
                                    ...ValuesFields
                                    subOptions {
                                      ...OptionsFields
                                      values {
                                        ...ValuesFields
                                        subOptions {
                                          ...OptionsFields
                                          values {
                                            ...ValuesFields
                                            subOptions {
                                              ...OptionsFields
                                              values {
                                                ...ValuesFields
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      orderStatus {
        currentProgress
        title
        subtitle
        description
        agent {
          phoneNumber
          name
        }
        locationMarkers {
          title
          latitude
          longitude
        }
      }
      isConfirmedMonitoringCall
      relatedPath {
        orderResolution {
          resolvedByOrderID
          resolvedOrderID
          redeliveryByOrderId
          resolvedWithoutReorder
        }
      }
      orderCharge {
        total
        card {
          total
          complete
        }
        credits {
          total
          complete
        }
        expiringCredits {
          expiringCreditId
          complete
          total
        }
      }
      schedule {
        id
        callerId
        day0
        day1
        day2
        day3
        day4
        day5
        day6
        deliveryDate
        deliveryTime
        endAfterXTimes
        endOn
        endOnType
        isRepeated
        dateTimes
        repeatEveryXWeek
        minutesToAutoRetryRequest
        minutesBeforeCustomReminder
        timeZone
        skipDates
        completedAt
        canceledAt
      }
      createdAt
      updatedAt
    }
  }
`);
